export default __webpack_public_path__ + "static/Barranquilla-activate-2ff59405d0c1e1abd41a3287bb696aca.svg";